import { ISelectOption } from '@smartshell/ui-kit';

import { ENDS } from 'cashbox';

export const taxOption: ISelectOption[] = [
  {
    value: ENDS.NO_NDS,
    title: 'Без НДС',
  },
  {
    value: ENDS.NDS_0,
    title: 'НДС 0%',
  },
  {
    value: ENDS.NDS_5,
    title: 'НДС 5%',
  },
  {
    value: ENDS.NDS_7,
    title: 'НДС 7%',
  },
  {
    value: ENDS.NDS_10,
    title: 'НДС 10%',
  },
  {
    value: ENDS.NDS_20,
    title: 'НДС 22%',
  },
  {
    value: ENDS.NDS_110,
    title: 'НДС 110%',
  },
  {
    value: ENDS.NDS_120,
    title: 'НДС 120%',
  },
];
